import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Opslevel = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 0 7.303 2.717v2.045L2.428 7.555v5.01l-2.09 1.209v5.435l4.697 2.719 1.662-.963L12 24l5.3-3.035 1.665.963 4.697-2.719v-5.436l-2.09-1.207V7.555l-4.877-2.793V2.717L11.998 0zm0 1.195 3.127 1.813L12 4.803 8.875 3.006l3.123-1.81zm-3.658 2.7L11.482 5.7v3.676L8.34 7.555v-3.66zm7.318 0v3.66L12.52 9.373V5.699l3.138-1.804zm1.037 2.062 3.842 2.197v3.813l-1.572-.91-4.697 2.716v5.436l1.998 1.156L12 22.805l-4.264-2.44 1.996-1.156v-5.436l-4.697-2.716-1.57.908v-3.81l3.838-2.196v2.195h.002L12 10.871l4.695-2.717V5.957zm-11.66 6.297 3.125 1.808-3.125 1.797-3.125-1.796.518-.301 2.607-1.508zm13.93 0 2.607 1.51.516.299-3.123 1.796-3.125-1.796 3.125-1.81zM1.377 14.949l3.142 1.809v3.676L1.377 18.61V14.95zm7.318 0v3.662L5.658 20.37l-.101.06v-3.673l3.138-1.807zm6.61 0 3.144 1.809v3.676l-.107-.065-3.037-1.758V14.95zm7.318 0v3.662l-3.139 1.819v-3.672l3.139-1.809z"
  }));
});
Opslevel.displayName = 'Opslevel';
export var OpslevelDimensions = {
  height: 24,
  width: 24
};